export const POST_ADD_SUCCESS = 'post/add';
export const POST_UPDATED_SUCCESS = 'post/update';
export const POST_DELETE_SUCCESS = 'post/delete';
export const POST_GET_SUCCESS = 'post/get';
export const ALLPOST_GET_SUCCESS = 'allpost/get';
export const POST_FUNC_LOADING = 'post/loading';
export const POST_FUNC_ERROR = 'post/error';